import assets from './asset-manifest.mjs';
const optimized=new Set(Object.values(assets));
const legacy=new Map(Object.entries(assets));
export function achievementIconName(value){
 const name=String(value||'');
 return optimized.has(name)?name:legacy.get(name)||'new-garden.webp';
}
export const achievementIconUrl=value=>'/images/achievements/'+achievementIconName(value);
